<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'

export default {
  
  watch: {
    '$store.state.theme'(val) {
      this.templateTheme(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    },
    '$store.state.menulayout'(val) {
      this.menuLayout(val)
    },
  },
  methods: {
    templateTheme(bodytheme) {      
      
        document.body.classList.remove('dark','semi-dark')
        document.body.classList.add(bodytheme)
    },
     menuLayout(menu) {     
        document.body.classList.remove('horizontal','vertical')
        document.body.classList.add(menu)
    },
     WindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
    }
  },
  mounted() {  
    this.templateTheme(themeConfig.theme)
    this.menuLayout(themeConfig.menulayout)
    this.WindowResize()
  }, 
  async created() {

    let dir = themeConfig.rtl ? "rtl" : "ltr"
    document.documentElement.setAttribute("dir", dir)
    window.addEventListener('resize', this.WindowResize)

  },
  destroyed() {
    window.removeEventListener('resize', this.WindowResize)
  },
}

</script>
